import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { clubAPI } from '../services/api';
import './ClubFund.css';

function ClubPendingBets() {
  const { clubId } = useParams();
  const [bets, setBets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    clubAPI.getPendingBets(clubId).then((data) => {
      setBets(data.bets || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [clubId]);

  return (
    <div>
      <h2>Pending Club Bets</h2>
      <p className="club-name">{bets.length} unresulted bet{bets.length !== 1 ? 's' : ''}</p>

      <div className="recent-transactions">
          {loading ? <p style={{ color: '#666' }}>Loading...</p> :
            bets.length === 0 ? <p className="no-transactions">No pending bets</p> :
            bets.map((bet) => (
              <div key={bet.betId} className="dark-card" style={{ background: 'rgba(0,0,0,0.25)', borderRadius: '8px', padding: '1rem', marginBottom: '0.75rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.4rem' }}>
                  <span style={{ color: '#fff', fontWeight: 600 }}>{bet.event || 'Unknown Event'}</span>
                  <span style={{ color: '#fbbf24', fontWeight: 700 }}>${bet.amount?.toFixed(2)}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem' }}>
                  <span style={{ color: '#999' }}>{bet.user}</span>
                  <span style={{ color: '#999' }}>@ ${bet.odds?.toFixed(2)}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.75rem', marginTop: '0.3rem' }}>
                  <span style={{ color: '#666' }}>{bet.datePlaced ? new Date(bet.datePlaced).toLocaleString() : '-'}</span>
                  <span style={{ color: '#fbbf24', fontSize: '0.7rem', textTransform: 'uppercase' }}>{bet.status}</span>
                </div>
              </div>
            ))
          }
      </div>
    </div>
  );
}

export default ClubPendingBets;
